export const CATEGORIES = {
  PROME: "Je Shopify pro mě?",
  PRVNIKRUCKY: "První kručky",
  PREKLAD: "Lokalizace",
  FAKTURACE: "Fakturace",
  PLATBA: "Platby a doprava",
  SROVNAVACE: "Srovnávače"
};
